import { coreApi } from "./coreApi";

export const plansApi = coreApi.injectEndpoints({
  endpoints: (builder) => ({
    getPlans: builder.query({
      query: () => ({
        url: "/administrator/plans",
        method: "GET",
      }),
    }),
    updatePlan: builder.mutation({
      query: (planId, plan) => ({
        url: `/administrator/plans/update/${planId}`,
        method: "POST",
        body: plan,
      }),
    }),
    getSpecificPlan: builder.query({
      query: (planId) => ({
        url: `/administrator/plans/show/${planId}`,
        method: "GET",
      }),
    }),
  }),
});

export const { useGetPlansQuery, useUpdatePlanMutation, useGetSpecificPlanQuery } = plansApi;
